import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const ACTIONS = {
  create: "Tambah",
  update: "Ubah",
  delete: "Hapus",
  import: "Impor Excel",
  renew: "Perpanjang Surat",
};

const Pick = ({ value, onChange, all, options, testId, className = "" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={`md:w-56 ${className}`} data-testid={testId}><SelectValue /></SelectTrigger>
    <SelectContent className="max-h-72">
      <SelectItem value="ALL">{all}</SelectItem>
      {options.map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const AuditFilters = ({ meta, user, f, setF }) => {
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  return (
    <div className="border bg-card p-3 flex flex-col md:flex-row gap-3">
      <Pick value={f.category} onChange={set("category")} all="Semua Kategori" testId="audit-category-filter"
        options={meta.categories.map((c) => [c.key, c.label])} />
      <Pick value={f.action} onChange={set("action")} all="Semua Aksi" testId="audit-action-filter"
        options={Object.entries(ACTIONS)} />
      {user.role !== "polda" && (
        <Pick value={f.polda} onChange={set("polda")} all="Semua (termasuk non-Polda)" testId="audit-polda-filter"
          options={meta.polda_list.map((p) => [p, p])} className="md:w-64" />
      )}
    </div>
  );
};
